import React, { Fragment, useState, useCallback } from "react";
import {
  LoadScript,
  Autocomplete,
  useLoadScript,
} from "@react-google-maps/api";
import { Config } from "../../config/Config";
import { decodeID, encodeID } from "../../utils/Helper";

interface LocationInputFieldProps {
  value?: string;
  placeholder?: string;
  onSuccess: (data: any) => void;
  onChange?: (data: any) => void;
  onClick?: (data: any) => void;
  onBlur?: (data: any) => void;
  className?: string
  id?: string
}

const LocationInputField = ({
  value,
  placeholder,
  onSuccess,
  onChange,
  onClick,
  onBlur,
  className,
  id
}: LocationInputFieldProps) => {

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: decodeID(Config?.GOOGLE_MAP_API_KEY),
    libraries: ["places"]
  });
  const [autocomplete, setAutocomplete] = useState<google.maps.places.Autocomplete | undefined>();
  const onLoad = useCallback((autocomplete: google.maps.places.Autocomplete) => {
    console.log(autocomplete , "[======>>>>autocomplete")
    setAutocomplete(autocomplete);
  }, []);

  const onPlaceChanged = () => {
    if (autocomplete && autocomplete.getPlace()) {
      console.log(autocomplete.getPlace())
      const place = autocomplete.getPlace();
      const addressComponents = place.address_components;
      let city = "";
      let state = "";
      let country = "";
      addressComponents?.forEach((component) => {
        if (component.types.includes("locality")) {
          city = component.long_name;
        }
        if (component.types.includes("administrative_area_level_1")) {
          state = component.long_name;
        }
        if (component.types.includes("country")) {
          country = component.long_name;
        }
      });

      const formattedAddress = place?.formatted_address;
      const place_name = place?.name;
      const latitudeLongitude = {
        lat: place.geometry?.location?.lat(),
        lng: place.geometry?.location?.lng(),
      };
      if (latitudeLongitude.lat && latitudeLongitude.lng) {
        onSuccess({ city, state, country, latitudeLongitude, formattedAddress, place_name });
      }
    }
  };


  if (!isLoaded) {
    return <>
      <input
        className={`${className ? className : 'f-input f-pass-input'}`}
        id={id}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onClick={onClick}
        onBlur={onBlur}
      />
    </>
  }

  return (
    <Autocomplete
      onLoad={onLoad}
      onPlaceChanged={onPlaceChanged} >
      <input
        className={`${className ? className : 'f-input f-pass-input'}`}
        id={id}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onClick={onClick}
        onBlur={onBlur}
      />
    </Autocomplete>
  );
};

export default React.memo(LocationInputField);